import {
	PortableText,
	PortableTextProps,
	PortableTextReactComponents,
} from '@portabletext/react';
import classNames from 'classnames';

import styles from './RichText.module.css';

interface RichTextProps extends PortableTextProps {
	className?: string;
}

const components: Partial<PortableTextReactComponents> = {
	block: {
		normal: ({ children }) => <p className="fluid-font-t5">{children}</p>,
		h1: ({ children }) => <h1 className="fluid-font-t3">{children}</h1>,
		h2: ({ children }) => <h2 className="fluid-font-t4-bold">{children}</h2>,
		h3: ({ children }) => <h3 className="fluid-font-t4">{children}</h3>,
		h4: ({ children }) => <h4 className="fluid-font-t5-bold">{children}</h4>,
	},
	marks: {
		link: ({ children, value }) => {
			return (
				<a href={value.href} rel="noreferrer noopener">
					{children}
				</a>
			);
		},
	},
};

export const RichText: React.FC<RichTextProps> = ({ className, ...props }) => {
	return (
		<div className={classNames(styles.wrapper, className)}>
			<PortableText components={components} {...props} />
		</div>
	);
};
